import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

const NavBar = ({ className }) => {
    return <Header containerClassName={className} logoClassName={style.logoPlaceholder} showAlertAction={false} />;
};

NavBar.defaultProps = {
    className: 'container',
};

NavBar.propTypes = {
    className: PropTypes.string,
};

export default NavBar;
